<template>
  <main class="get-started">
    <div class="cover-wrapper">
      <div class="title">
        <span>Welcome to</span>
        <img :src="themeImage('raise-logo-without-icon.svg')" />
      </div>
      <p>Fill last minute shifts with verified Wagestream workers and trial candidates for full time jobs.</p>
      <img src="./images/raise-get-started-cover.png" />
    </div>
    <div class="actions-wrapper">
      <RecommendedAction
        v-if="!props.onboarding"
        label="Talents"
        title="Find workers near you"
        description="Check out their profile"
        @click="
          route.name === 'talent-pool-map'
            ? $bvModal.hide('help-modal')
            : $router.push({ name: 'talent-pool-map', params: { locationId: companyId } })
        "
      >
        <template v-slot:icon>
          <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.66602 8.12484C6.66602 6.2865 8.16102 4.7915 9.99935 4.7915C11.8377 4.7915 13.3327 6.2865 13.3327 8.12484C13.3327 9.96317 11.8377 11.4582 9.99935 11.4582C8.16102 11.4582 6.66602 9.96317 6.66602 8.12484ZM8.33268 8.12484C8.33268 9.044 9.08018 9.7915 9.99935 9.7915C10.9185 9.7915 11.666 9.044 11.666 8.12484C11.666 7.20567 10.9185 6.45817 9.99935 6.45817C9.08018 6.45817 8.33268 7.20567 8.33268 8.12484Z"
              fill="currentColor"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M9.99935 1.0415C11.8918 1.0415 13.6693 1.77817 15.0085 3.1165C16.346 4.454 17.0827 6.23234 17.0827 8.12484C17.0827 14.1148 10.7468 18.619 10.4768 18.8073C10.3335 18.9073 10.166 18.9582 9.99935 18.9582C9.83268 18.9582 9.66518 18.9073 9.52185 18.8073C9.25185 18.619 2.91602 14.1148 2.91602 8.12484C2.91602 6.23234 3.65268 4.454 4.99102 3.1165C6.32852 1.77817 8.10685 1.0415 9.99935 1.0415ZM4.58268 8.12484C4.58268 12.379 8.59352 15.9548 9.99852 17.0765C11.4035 15.9532 15.416 12.3682 15.416 8.12484C15.416 6.67817 14.8527 5.31734 13.8302 4.29484C12.806 3.2715 11.446 2.70817 9.99935 2.70817C8.55268 2.70817 7.19268 3.27234 6.16935 4.29484C5.14602 5.31734 4.58268 6.67817 4.58268 8.12484Z"
              fill="currentColor"
            />
          </svg>
        </template>
      </RecommendedAction>

      <RecommendedAction
        v-if="!props.onboarding"
        v-b-modal="'add-colleague-modal'"
        label="Team"
        title="Invite colleagues"
        description="Don't do everything yourself"
      >
        <template v-slot:icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.0001 8.375C9.37671 8.375 7.25006 10.5016 7.25006 13.125C7.25006 14.5208 7.85212 15.776 8.81071 16.6451C8.63243 16.7362 8.45769 16.8351 8.287 16.9417C7.17342 17.6372 6.27755 18.6315 5.70147 19.8113C5.45914 20.3075 5.66501 20.9063 6.16129 21.1486C6.65757 21.391 7.25633 21.1851 7.49866 20.6888C7.91037 19.8457 8.55062 19.1351 9.34646 18.638C10.1423 18.141 11.0618 17.8774 12.0001 17.8774C12.9384 17.8774 13.8578 18.141 14.6537 18.638C15.4495 19.1351 16.0898 19.8457 16.5015 20.6888C16.7438 21.1851 17.3426 21.391 17.8388 21.1486C18.3351 20.9063 18.541 20.3075 18.2987 19.8113C17.7226 18.6315 16.8267 17.6372 15.7131 16.9417C15.5424 16.8351 15.3677 16.7362 15.1894 16.6451C16.148 15.776 16.7501 14.5208 16.7501 13.125C16.7501 10.5016 14.6234 8.375 12.0001 8.375ZM9.25006 13.125C9.25006 11.6062 10.4813 10.375 12.0001 10.375C13.5188 10.375 14.7501 11.6062 14.7501 13.125C14.7501 14.6438 13.5188 15.875 12.0001 15.875C10.4813 15.875 9.25006 14.6438 9.25006 13.125Z"
              fill="currentColor"
            />
            <path
              d="M5.00312 5.97317C5.36408 5.8557 5.75103 5.84339 6.11873 5.93766C6.48644 6.03194 6.81972 6.22891 7.07964 6.50557C7.33955 6.78222 7.51537 7.12713 7.58655 7.5C7.6901 8.04249 8.21382 8.39832 8.75631 8.29476C9.2988 8.19121 9.65463 7.66749 9.55108 7.125C9.40873 6.37927 9.05709 5.68944 8.53726 5.13613C8.01742 4.58282 7.35085 4.18888 6.61544 4.00032C5.88003 3.81177 5.10615 3.8364 4.38422 4.07134C3.66228 4.30627 3.02212 4.74181 2.53852 5.32706C2.05492 5.9123 1.74786 6.62309 1.65322 7.37636C1.55858 8.12964 1.68027 8.89429 2.00406 9.58098C2.17506 9.94364 2.39871 10.2766 2.66618 10.57L2.66128 10.5724C1.74062 11.0328 0.940272 11.7019 0.324058 12.5263C-0.00657375 12.9687 0.0840178 13.5954 0.526399 13.926C0.968781 14.2566 1.59543 14.166 1.92606 13.7237C2.35572 13.1488 2.91377 12.6823 3.5557 12.3613C4.19764 12.0403 4.90569 11.8738 5.62339 11.875C6.17567 11.8759 6.62413 11.429 6.62506 10.8767L6.62506 10.874C6.62497 10.7807 6.6121 10.6904 6.58811 10.6047C6.4701 10.1834 6.08303 9.87453 5.62405 9.875C5.24445 9.87538 4.87258 9.76773 4.55189 9.56462C4.2312 9.36151 3.97494 9.07133 3.81304 8.72799C3.65114 8.38465 3.5903 8.00232 3.63762 7.62568C3.68494 7.24904 3.83847 6.89365 4.08027 6.60103C4.32207 6.3084 4.64215 6.09064 5.00312 5.97317Z"
              fill="currentColor"
            />
            <path
              d="M17.8814 5.93766C18.2491 5.84339 18.636 5.8557 18.997 5.97317C19.358 6.09064 19.6781 6.3084 19.9198 6.60103C20.1616 6.89365 20.3152 7.24904 20.3625 7.62568C20.4098 8.00232 20.349 8.38465 20.1871 8.72799C20.0252 9.07133 19.7689 9.36151 19.4482 9.56462C19.1275 9.76773 18.7557 9.87538 18.3761 9.875C17.8238 9.87444 17.3756 10.3217 17.3751 10.874C17.3749 11.0121 17.4028 11.1436 17.4532 11.2633C17.548 11.488 17.7225 11.6708 17.9414 11.7763C18.073 11.8398 18.2207 11.8753 18.3767 11.875C19.0944 11.8738 19.8025 12.0403 20.4444 12.3613C21.0863 12.6823 21.6444 13.1488 22.0741 13.7237C22.4047 14.166 23.0313 14.2566 23.4737 13.926C23.9161 13.5954 24.0067 12.9687 23.6761 12.5263C23.0598 11.7019 22.2595 11.0328 21.3388 10.5724L21.3339 10.57C21.6014 10.2766 21.8251 9.94364 21.9961 9.58098C22.3199 8.89429 22.4415 8.12964 22.3469 7.37636C22.2523 6.62309 21.9452 5.9123 21.4616 5.32706C20.978 4.74181 20.3378 4.30627 19.6159 4.07134C18.894 3.8364 18.1201 3.81177 17.3847 4.00032C16.6493 4.18888 15.9827 4.58282 15.4629 5.13613C14.943 5.68944 14.5914 6.37927 14.449 7.125C14.3455 7.66749 14.7013 8.19121 15.2438 8.29476C15.7863 8.39832 16.31 8.04249 16.4136 7.5C16.4847 7.12713 16.6606 6.78222 16.9205 6.50557C17.1804 6.22891 17.5137 6.03194 17.8814 5.93766Z"
              fill="currentColor"
            />
          </svg>
        </template>
      </RecommendedAction>

      <RecommendedAction
        v-if="!props.onboarding"
        label="Company"
        title="Manage Brands & Sites"
        description="Tell us about the roles you need"
        @click="navigateToCompanySettings"
      >
        <template v-slot:icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M22 8.79995V8.69995L20.6 3.99995C20.5 3.59995 20.3 3.29995 20 3.09995C19.7 2.89995 19.3 2.69995 18.9 2.69995H5.1C4.7 2.69995 4.4 2.79995 4.1 3.09995C3.7 3.29995 3.5 3.69995 3.4 3.99995L2 8.69995V8.79995C2 8.89995 2 8.89995 2 8.99995V10.5C2 11.6 2.4 12.6 3.2 13.3C3.3 13.4 3.4 13.5 3.5 13.6V19.5C3.5 20 3.7 20.4 4 20.7C4.3 21 4.8 21.2 5.2 21.2H18.7C19.2 21.2 19.6 21 19.9 20.7C20.2 20.4 20.4 19.9 20.4 19.5V13.6C20.5 13.5 20.6 13.4 20.7 13.3C21.5 12.5 21.9 11.5 21.9 10.5V8.99995C22 8.89995 22 8.89995 22 8.79995ZM20 9.99995V10.5C20 11 19.8 11.5 19.4 11.9C18.6 12.7 17.3 12.7 16.6 11.9C16.2 11.5 16 11 16 10.5V9.99995H20ZM10 9.99995H14V10.5C14 11 13.8 11.5 13.4 11.9C12.7 12.6 11.3 12.6 10.6 11.9C10.2 11.5 10 11 10 10.5V9.99995ZM5.3 4.79995H18.8L19.7 7.99995H4.3L5.3 4.79995ZM8 9.99995V10.5C8 11 7.8 11.5 7.4 11.9C6.7 12.6 5.3 12.6 4.6 11.9C4.2 11.5 4 11 4 10.5V9.99995H8ZM18.5 19.2H5.5V14.4C5.7 14.4 5.8 14.4 6 14.4C7.1 14.4 8.1 14 8.8 13.2C8.9 13.1 8.9 13.1 9 13C9.1 13.1 9.1 13.1 9.2 13.2C10 14 11 14.4 12 14.4C13 14.4 14.1 14 14.8 13.2C14.9 13.1 14.9 13.1 15 13C15.1 13.1 15.1 13.1 15.2 13.2C16 14 17 14.4 18 14.4C18.2 14.4 18.3 14.4 18.5 14.4V19.2Z"
              fill="currentColor"
            /></svg></template
      ></RecommendedAction>
    </div>
    <div class="content-wrapper">
      <Step
        :step="1"
        title="Add a shift or job"
        description="Fill-up the quick form to add a shift or a full time job for one of your sites. Select the role, date and time and come back
            later to pick your favourite worker."
        imageName="raise-add-shift.png"
        ><b-button v-if="!props.onboarding" variant="primary" v-b-modal="'add-shift-modal'"
          ><font-awesome-icon :icon="['fal', 'plus']" class="mr-2" />Add your first shift</b-button
        ></Step
      >
      <Step
        :step="2"
        title="Selecting a worker"
        description="Once workers apply for your shift, you can review their profile and pick the best candidate for the job. "
        imageName="raise-select-worker.png"
        ><p>
          To minimise risk of no-shows, we require all workers to confirm attendance shortly after you pick them for a
          shift.
        </p></Step
      >
      <img class="timeline-image" src="./images/raise-shift-timeline.png" />
      <Step
        :step="3"
        title="Shift sign-in & sign-off"
        description="Scan the worker's QR code when they start and finish their shift. Anyone added to your team in Raise can sign-in & sign-off shifts."
        imageName="raise-sign-off.png"
      >
        <b-button v-if="!props.onboarding" variant="primary" v-b-modal="'add-colleague-modal'">
          <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.99971 5.5835C6.25081 5.5835 4.83305 7.00126 4.83305 8.75016C4.83305 9.68071 5.23442 10.5175 5.87348 11.0969C5.75463 11.1576 5.63813 11.2236 5.52434 11.2946C4.78195 11.7583 4.18471 12.4211 3.80065 13.2077C3.6391 13.5385 3.77635 13.9377 4.1072 14.0993C4.43805 14.2608 4.83723 14.1236 4.99878 13.7927C5.27325 13.2306 5.70008 12.7569 6.23065 12.4255C6.76121 12.0941 7.37418 11.9185 7.99972 11.9185C8.62526 11.9185 9.23822 12.0941 9.76879 12.4255C10.2993 12.7569 10.7262 13.2306 11.0007 13.7927C11.1622 14.1236 11.5614 14.2608 11.8922 14.0993C12.2231 13.9377 12.3603 13.5385 12.1988 13.2077C11.8147 12.4211 11.2175 11.7583 10.4751 11.2946C10.3613 11.2236 10.2448 11.1576 10.1259 11.0969C10.765 10.5175 11.1664 9.68071 11.1664 8.75016C11.1664 7.00126 9.74862 5.5835 7.99971 5.5835ZM6.16638 8.75016C6.16638 7.73764 6.98719 6.91683 7.99971 6.91683C9.01224 6.91683 9.83305 7.73764 9.83305 8.75016C9.83305 9.76268 9.01224 10.5835 7.99971 10.5835C6.98719 10.5835 6.16638 9.76268 6.16638 8.75016Z"
              fill="currentColor"
            />
            <path
              d="M3.33509 3.98228C3.57573 3.90396 3.83369 3.89575 4.07883 3.9586C4.32397 4.02145 4.54615 4.15277 4.71943 4.33721C4.89271 4.52164 5.00992 4.75158 5.05737 5.00016C5.12641 5.36182 5.47556 5.59904 5.83722 5.53C6.19888 5.46097 6.43609 5.11182 6.36706 4.75016C6.27216 4.25301 6.03773 3.79312 5.69118 3.42425C5.34462 3.05538 4.90024 2.79275 4.40997 2.66705C3.9197 2.54135 3.40377 2.55777 2.92248 2.71439C2.4412 2.87101 2.01442 3.16137 1.69202 3.55153C1.36962 3.9417 1.16492 4.41556 1.10182 4.91774C1.03873 5.41992 1.11985 5.92969 1.33571 6.38748C1.44972 6.62926 1.59881 6.85126 1.77713 7.04683L1.77386 7.04846C1.16009 7.35534 0.626523 7.8014 0.215713 8.35106C-0.00470801 8.64598 0.0556864 9.06375 0.350607 9.28417C0.645528 9.50459 1.0633 9.4442 1.28372 9.14928C1.57016 8.76602 1.94219 8.455 2.37014 8.24103C2.7981 8.02705 3.27013 7.91603 3.7486 7.91683C4.11679 7.91745 4.41576 7.61947 4.41638 7.25128L4.41638 7.24949C4.41632 7.18728 4.40774 7.12708 4.39175 7.06997C4.31308 6.78907 4.05503 6.58319 3.74904 6.5835C3.49597 6.58375 3.24806 6.51198 3.03427 6.37658C2.82048 6.24117 2.64963 6.04772 2.5417 5.81882C2.43377 5.58993 2.39321 5.33504 2.42475 5.08395C2.4563 4.83286 2.55865 4.59593 2.71985 4.40085C2.88105 4.20577 3.09444 4.06059 3.33509 3.98228Z"
              fill="currentColor"
            />
            <path
              d="M11.9206 3.9586C12.1657 3.89575 12.4237 3.90396 12.6643 3.98228C12.905 4.06059 13.1184 4.20577 13.2796 4.40085C13.4408 4.59593 13.5431 4.83286 13.5747 5.08395C13.6062 5.33504 13.5657 5.58993 13.4577 5.81882C13.3498 6.04772 13.179 6.24117 12.9652 6.37658C12.7514 6.51198 12.5035 6.58375 12.2504 6.5835C11.8822 6.58312 11.5834 6.8813 11.583 7.24949C11.583 7.34153 11.6015 7.42924 11.6352 7.50904C11.6983 7.65882 11.8147 7.78071 11.9606 7.85104C12.0484 7.89336 12.1468 7.91701 12.2508 7.91683C12.7293 7.91603 13.2013 8.02705 13.6293 8.24103C14.0572 8.455 14.4293 8.76602 14.7157 9.14927C14.9361 9.4442 15.3539 9.50459 15.6488 9.28417C15.9437 9.06375 16.0041 8.64598 15.7837 8.35106C15.3729 7.8014 14.8393 7.35534 14.2256 7.04846L14.2223 7.04683C14.4006 6.85126 14.5497 6.62925 14.6637 6.38748C14.8796 5.92969 14.9607 5.41992 14.8976 4.91774C14.8345 4.41556 14.6298 3.9417 14.3074 3.55153C13.985 3.16137 13.5582 2.87101 13.0769 2.71439C12.5957 2.55777 12.0797 2.54135 11.5895 2.66705C11.0992 2.79275 10.6548 3.05538 10.3082 3.42425C9.96169 3.79312 9.72727 4.25301 9.63237 4.75016C9.56333 5.11182 9.80055 5.46097 10.1622 5.53C10.5239 5.59904 10.873 5.36182 10.9421 5.00016C10.9895 4.75158 11.1067 4.52164 11.28 4.33721C11.4533 4.15277 11.6755 4.02145 11.9206 3.9586Z"
              fill="currentColor"
            />
          </svg>
          Invite colleague
        </b-button>
      </Step>
      <div v-if="!props.onboarding" class="access">
        <img src="./images/raise-show-help.png" />
        <p>You can access this screen anytime by clicking the ? button next to your profile</p>
      </div>
    </div>

    <!-- TODO: add link to intercom -->
    <!-- <div class="help-wrapper">
      <p>Need more help?</p>
      <button>
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.43102 17.4246C7.56511 17.3031 6.72094 17.0354 5.93601 16.6281L3.99915 17.1804L3.9956 17.1814C3.72843 17.2565 3.44607 17.2591 3.17756 17.1889C2.90905 17.1188 2.66408 16.9783 2.46784 16.7821C2.2716 16.5858 2.13116 16.3409 2.06098 16.0724C1.9908 15.8038 1.9934 15.5215 2.06851 15.2543L2.06952 15.2508L2.6218 13.3139C1.82319 11.7747 1.56125 10.0077 1.88572 8.29568C2.23776 6.4382 3.25582 4.77313 4.74873 3.61321C6.24163 2.45329 8.10665 1.87831 9.99352 1.99627C11.8804 2.11422 13.6593 2.917 14.9961 4.25382C15.6717 4.92938 16.2108 5.71785 16.5942 6.57609C17.6844 6.72999 18.732 7.11514 19.6655 7.70871C20.7906 8.42412 21.7119 9.41804 22.3401 10.5942C22.9682 11.7703 23.2819 13.0887 23.2507 14.4217C23.223 15.6064 22.9237 16.767 22.3783 17.8147L22.9314 19.7543C23.0065 20.0215 23.0091 20.3039 22.9389 20.5724C22.8687 20.8409 22.7283 21.0859 22.532 21.2821C22.3358 21.4783 22.0908 21.6188 21.8223 21.6889C21.5538 21.7591 21.2714 21.7565 21.0043 21.6814L21.0007 21.6804L19.0643 21.1282C18.1808 21.5873 17.2158 21.8723 16.2218 21.9661C15.0805 22.0737 13.9295 21.9265 12.852 21.535C11.7744 21.1436 10.7973 20.5177 9.99121 19.7025C9.3376 19.0416 8.80964 18.2697 8.43102 17.4246ZM5.9758 5.19254C7.08391 4.33159 8.46821 3.90482 9.86873 3.99237C11.2693 4.07992 12.5896 4.67578 13.5819 5.66803C14.1497 6.23584 14.5877 6.91111 14.8749 7.64735C14.8935 7.78173 14.939 7.90811 15.0059 8.02052C15.1432 8.45916 15.2285 8.91574 15.2575 9.38118C15.3451 10.7817 14.9183 12.166 14.0574 13.2741C13.1964 14.3822 11.9605 15.1379 10.5818 15.3992C9.20311 15.6605 7.77643 15.4094 6.56973 14.6932C6.33329 14.5528 6.04951 14.516 5.7851 14.5914L4.2091 15.0408L4.65848 13.4648C4.73388 13.2004 4.69708 12.9166 4.55674 12.6802C3.8405 11.4735 3.58945 10.0468 3.85075 8.6681C4.11204 7.28938 4.8677 6.05349 5.9758 5.19254ZM17.206 8.75568C17.2272 8.92158 17.2432 9.08856 17.2537 9.2564C17.3716 11.1433 16.7966 13.0083 15.6367 14.5012C14.4768 15.9941 12.8117 17.0122 10.9542 17.3642C10.868 17.3805 10.7817 17.3954 10.6953 17.4088C10.9039 17.7267 11.1442 18.0242 11.4133 18.2962C12.0111 18.9007 12.7358 19.3649 13.5349 19.6552C14.334 19.9455 15.1876 20.0547 16.034 19.9749C16.8805 19.8951 17.6987 19.6282 18.4294 19.1936C18.666 19.0529 18.9501 19.016 19.2148 19.0914L20.7908 19.5408L20.3414 17.9648C20.2658 17.6999 20.3029 17.4155 20.444 17.1788C20.95 16.3293 21.2281 15.3635 21.2512 14.3749C21.2744 13.3863 21.0417 12.4086 20.5759 11.5363C20.1101 10.6641 19.4268 9.927 18.5924 9.39643C18.1591 9.12091 17.6926 8.90595 17.206 8.75568Z"
            fill="black"
          />
        </svg>
        Chat to us
      </button>
    </div> -->
  </main>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router/composables';
import ApiClient from '@/ApiClient';
import { getEntityType } from '@/pages/talent-pool/utils/getEntityType';
import { onMounted, ref } from 'vue';
import { themeImage } from '@/Theme';
import Step from '@/pages/talent-pool/components/GetStarted/components/Step.vue';
import RecommendedAction from '@/pages/talent-pool/components/GetStarted/components/RecommendedAction.vue';
import State from '@/state/State';

const $router = useRouter();
const route = useRoute();

const props = defineProps({
  onboarding: {
    type: Boolean,
    default: false,
  },
});

const companyId = State.state.company.company_id;
const organisation = ref([]);

const getOrganisation = async () => {
  const { data } = await ApiClient.getTalentPoolOrganisation();
  organisation.value =
    data.children.filter(org => getEntityType(org.source) !== 'brand' || org.children?.length > 0) || [];
};

const navigateToCompanySettings = () => {
  $router.push({ name: 'talent-pool-settings', params: { locationId: companyId } });
};

onMounted(() => {
  getOrganisation();
});
</script>

<style scoped lang="scss">
.get-started {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--palette-color-base-white);
  padding: 1.5rem 3.25rem;
}

.cover-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
.cover-wrapper .title {
  display: flex;
  align-items: flex-end;
  gap: 0.375rem;
}
.cover-wrapper .title img {
  margin-bottom: 0.625rem;
  width: 88px;
}
.cover-wrapper .title span {
  font-size: 1.5rem;
  font-weight: 400;
  color: var(--palette-color-default);
}
.cover-wrapper p {
  font-size: 1rem;
  font-weight: 400;
  color: var(--palette-color-default);
  text-align: center;
}
.cover-wrapper img {
  width: 80%;
  max-width: 1024px;
}

.actions-wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  width: 100%;
  margin-top: 1.5rem;
  margin-bottom: 5rem;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5rem;
}
.timeline-image {
  width: 100%;
  max-width: 1024px;
}

.access {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  margin-bottom: 3rem;
}
.access p {
  font-size: 13px;
  font-weight: 400;
  color: var(--palette-color-default-lighten-20);
}
.access img {
  width: 50%;
  max-width: 600px;
  min-width: 250px;
  border-radius: 0.75rem;
  border: 1px solid var(--palette-color-success-lighten-90);
}

.help-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 4rem;
}
.help-wrapper p {
  font-size: 20px;
  font-weight: 500;
  color: var(--palette-color-default);
  margin: 0;
}
.help-wrapper button {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: 1px solid var(--palette-color-default);
  border: 1px solid var(--palette-color-default-lighten-90);
  background: var(--palette-color-base-white);
  border-radius: 99px;
  padding: 0.5rem 1.5rem 0.5rem 1.25rem;
  width: fit-content;
  gap: 0.5rem;
  transition: all ease-out 180ms;
}
.help-wrapper button:hover {
  border-color: var(--palette-color-base-white);
  box-shadow: 0px 0px 2px 0px rgba(34, 40, 47, 0.05), 0px 2px 10px 0px rgba(34, 40, 47, 0.1);
  transition: all ease-out 180ms;
}
.help-wrapper button:active {
  border-color: var(--palette-color-default-lighten-90);
  box-shadow: unset;
  transition: all 0ms;
  opacity: 0.5;
}

@media (max-width: 1000px) {
  .cover-wrapper img {
    width: 100%;
  }
}
</style>
